import {
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { WindowService } from '~/core/services/window/window.service';
import { RedirectionService } from '~/core/services/redirection/redirection.service';

@Component({
  selector: 'app-redirect-external',
  templateUrl: './redirect-external.component.html',
  styleUrls: ['./redirect-external.component.scss'],
})
export class RedirectExternalComponent implements OnDestroy, OnInit {
  @ViewChild('redirectButton') redirectButton: ElementRef<HTMLElement>;

  private readonly subscriptions = new Subscription();

  public url: string;

  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: string,
    protected readonly activatedRoute: ActivatedRoute,
    private readonly redirectionService: RedirectionService,
    private readonly translateService: TranslateService,
    private readonly windowService: WindowService
  ) {}

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public get redirectionTitle(): string {
    return this.translateService.instant('checkout.redirection.title');
  }

  public ngOnInit(): void {
    this.subscriptions.add(
      this.activatedRoute.data.subscribe(({ externalUrl }) => {
        this.url = decodeURIComponent(externalUrl?.url);
        setTimeout(() => this.redirectButton.nativeElement.click(), 1000);
      })
    );
  }

  public redirectionPartnerHandler(url): void {
    if (isPlatformBrowser(this.platformId)) {
      const activitySku = localStorage.getItem('fromActivity');
      this.windowService.openNewTab(url);
      setTimeout(
        () =>
          this.redirectionService.redirect(
            `/attendee.show-activity/${activitySku}`
          ),
        2000
      );
      localStorage.removeItem('fromActivity');
    }
  }
}
